import request from '../../services/request';

export const getAssemblies = async () => request.get('assembleiasvirtuais?o=-dataPublicacao');
